import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { isTypeString } from 'utils/helpers';
import { INSIGHT_HEADER_WIDTHS } from './constants';
import { InsightPanelSize } from './types';
import { InsightType } from '../domain';
import { ConversionRateSelect } from './ConversionRateSelect';

export type InsightHeaderProps = {
  size?: InsightPanelSize;
  title?: string | React.ReactNode;
  showDivider?: boolean;
  showSelect?: boolean;
  type?: InsightType | null;
};

export const Header = styled.div<{ $title: string; $type: InsightType | null }>`
  font-size: ${({ theme }) => theme.styles.fontSizes.s14};
  font-weight: ${({ theme }) => theme.styles.fontWeights.semiBold};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  flex-grow: 0;
  max-width: ${({ $type }) => $type && INSIGHT_HEADER_WIDTHS[$type]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const WRAPPER_HEIGHT = {
  [InsightPanelSize.small]: 'min-content',
  [InsightPanelSize.medium]: pxToRem(52),
};

export const Wrapper = styled.div<{ $showDivider?: boolean; size?: InsightPanelSize }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: ${({ size }) => size && WRAPPER_HEIGHT[size]};
  margin: 0 -${({ theme }) => theme.spacing.values.base} 0 -${({ theme }) =>
    theme.spacing.values.plusHalf};
  border-bottom: ${({ theme, $showDivider }) =>
    $showDivider &&
    `
    ${theme.spacing.values.single} solid #bdbdbd
  `};
  padding: ${({ theme }) => `
    0 ${theme.spacing.values.base} ${theme.spacing.values.base} ${theme.spacing.values.plusHalf}
  `};
`;

export const INSIGHT_HEADER = 'insight-header';

export const InsightHeader = ({
  title,
  size,
  showDivider = false,
  showSelect = false,
  type = null,
}: InsightHeaderProps) => {
  const insightTitle = isTypeString(title) ? title : '';

  if (!title) return null;

  return (
    <Wrapper data-test={title} $showDivider={showDivider} size={size}>
      <Header data-test={INSIGHT_HEADER} $title={insightTitle} $type={type}>
        {title}
      </Header>
      {showSelect && <ConversionRateSelect />}
    </Wrapper>
  );
};
